import { render, staticRenderFns } from "./assetTransfer.vue?vue&type=template&id=ceb241d4&scoped=true&"
import script from "./assetTransfer.vue?vue&type=script&lang=js&"
export * from "./assetTransfer.vue?vue&type=script&lang=js&"
import style0 from "./assetTransfer.vue?vue&type=style&index=0&id=ceb241d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb241d4",
  null
  
)

export default component.exports